import React from "react";
/** Moment */
import moment from 'moment';
import momentConfig from '../config/moment.config';
moment.locale('fr', momentConfig);

export default moment;